(function(angular){
    'use strict';

    angular.module('nucleus.widgets').directive('driveUsageWidget', driveUsageWidget);
    driveUsageWidget.$inject = [];

    function driveUsageWidget(){
        return {
            restrict: 'EA',
            templateUrl: 'dashboard/widgets/drive/drive-usage-widget.2js.html',
            scope: {
                widgetData: '='
            },
            link: function(){

            }
        };
    }
})(window.angular);
